import { Button, Flex, Result } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { useAppSelector } from "@/hooks/redux";
import { logoutService } from "@/Services/Logout";

const ResultWrapper = styled.div`
    .ant-result-title,
    .ant-result-subtitle {
        color: black;
    }
`;

export const Unauthorized = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAppSelector((s) => s.auth);

    return (
        <ResultWrapper>
            <Result
                status="403"
                title="403"
                subTitle="Вибачте, у вас немає доступу до цієї сторінки."
                extra={
                    <Flex vertical gap={8}>
                        <Button onClick={() => navigate("/")} type="primary">
                            Повернутися на головну
                        </Button>

                        {isAuthenticated && (
                            <Button onClick={() => logoutService()}>
                                Вийти з облікового запису
                            </Button>
                        )}
                    </Flex>
                }
            />
        </ResultWrapper>
    );
};
